var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check as CheckIcon, ChevronLeft, Close as CloseIcon, ErrorOutline as ErrorIcon, Lock as LockIcon, Visibility as VisibilityIcon, } from '@mui/icons-material';
import { Avatar, Box, Button, Card, Chip, IconButton, MenuItem, Pagination, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, } from '@mui/material';
import { ModalVisualizar, ModalAprovar, ModalReprovar } from './components';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { STATUS_API } from '../../../api';
import ContainerPainel from '../../../components/container_painel';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { getHistoricoReeducando, getDetalheValidacaoDia, aprovarPonto, reprovarPonto, aprovarPontoPorData, reprovarPontoPorData, } from './validacao_diaria_service';
var COLORS = {
    primary: '#00673D',
    status: {
        pendente: { bg: '#F3F4F6', text: '#374151' },
        regular: { bg: '#FEF9C3', text: '#854D0E' },
        alerta: { bg: '#FEF9C3', text: '#854D0E' },
        analise: { bg: '#DBEAFE', text: '#1E40AF' },
        aprovado: { bg: '#DCFCE7', text: '#166534' },
        reprovado: { bg: '#FEE2E2', text: '#991B1B' },
        funac: { bg: '#DCFCE7', text: '#166534' }, // Verde claro (com cadeado)
    },
};
var POLLING_SINCRONIZACAO_MS = 10000;
var TIPOS_BATIDA = ['E1', 'S1', 'E2', 'S2'];
var formatarDataIso = function (data) {
    var ano = data.getUTCFullYear();
    var mes = String(data.getUTCMonth() + 1).padStart(2, '0');
    var dia = String(data.getUTCDate()).padStart(2, '0');
    return "".concat(ano, "-").concat(mes, "-").concat(dia);
};
var getPeriodoPadraoHistorico = function () {
    var hoje = new Date();
    var inicio = new Date(Date.UTC(hoje.getFullYear(), hoje.getMonth() - 2, 1));
    var fim = new Date(Date.UTC(hoje.getFullYear(), hoje.getMonth() + 1, 0));
    return {
        dataInicio: formatarDataIso(inicio),
        dataFim: formatarDataIso(fim),
    };
};
var getDataKey = function (dataStr) { return dataStr.slice(0, 10); };
var getDataUtc = function (dataStr) { return new Date("".concat(getDataKey(dataStr), "T00:00:00.000Z")); };
var getHojeUtc = function () {
    var hoje = new Date();
    return new Date(Date.UTC(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()));
};
var getBatidasObrigatorias = function (cargaHoraria) {
    return Number(cargaHoraria) <= 6 ? ['E1', 'S1'] : ['E1', 'S1', 'E2', 'S2'];
};
var getCodigoColaborador = function (colaborador) {
    var _a, _b, _c;
    var codigo = ((_a = colaborador === null || colaborador === void 0 ? void 0 : colaborador.reeducando) === null || _a === void 0 ? void 0 : _a.codigo) || (colaborador === null || colaborador === void 0 ? void 0 : colaborador.codigo) || (colaborador === null || colaborador === void 0 ? void 0 : colaborador.codigo_colaborador);
    if (codigo)
        return codigo;
    var idColaborador = ((_b = colaborador === null || colaborador === void 0 ? void 0 : colaborador.reeducando) === null || _b === void 0 ? void 0 : _b.id) || (colaborador === null || colaborador === void 0 ? void 0 : colaborador.reeducando_id) || (colaborador === null || colaborador === void 0 ? void 0 : colaborador.id);
    if (idColaborador)
        return "FUNAC - ".concat(idColaborador);
    return ((_c = colaborador === null || colaborador === void 0 ? void 0 : colaborador.reeducando) === null || _c === void 0 ? void 0 : _c.matricula) || (colaborador === null || colaborador === void 0 ? void 0 : colaborador.matricula) || 'N/A';
};
var getInfoColaborador = function (colaborador) {
    var _a, _b, _c;
    if (!colaborador)
        return null;
    return {
        nome: ((_a = colaborador.reeducando) === null || _a === void 0 ? void 0 : _a.nome) || colaborador.reeducando_nome || colaborador.nome || 'N/A',
        codigo: getCodigoColaborador(colaborador),
        empresa: ((_b = colaborador.contrato) === null || _b === void 0 ? void 0 : _b.nome) || colaborador.empresa_nome || (typeof colaborador.contrato === 'string' ? colaborador.contrato : 'N/A'),
        cargaHoraria: Number(colaborador.carga_horaria_diaria || ((_c = colaborador.contrato) === null || _c === void 0 ? void 0 : _c.carga_horaria_diaria) || 8),
    };
};
export function ValidacaoDiariaDetalhes() {
    var _this = this;
    var _a;
    var navigate = useNavigate();
    var location = useLocation();
    var id = useParams().id;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), historico = _c[0], setHistorico = _c[1];
    var _d = useState(null), reeducandoInfo = _d[0], setReeducandoInfo = _d[1];
    var _e = useState(function () { return getPeriodoPadraoHistorico(); }), periodoConsulta = _e[0], setPeriodoConsulta = _e[1];
    var _f = useState(function () { return getPeriodoPadraoHistorico(); }), filtrosPeriodo = _f[0], setFiltrosPeriodo = _f[1];
    var _g = useState(1), pagina = _g[0], setPagina = _g[1];
    var _h = useState(15), porPagina = _h[0], setPorPagina = _h[1];
    var _j = useState(false), modalOpen = _j[0], setModalOpen = _j[1];
    var _k = useState(null), diaSelecionado = _k[0], setDiaSelecionado = _k[1];
    var _l = useState(false), modalDetalheLoading = _l[0], setModalDetalheLoading = _l[1];
    var handleOpenModal = function (dia) { return __awaiter(_this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setDiaSelecionado(dia);
                    setModalOpen(true);
                    if (!dia.id)
                        return [2 /*return*/];
                    setModalDetalheLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getDetalheValidacaoDia(dia.id)];
                case 2:
                    response = _b.sent();
                    if (response.Status === STATUS_API.OK) {
                        setDiaSelecionado(response.dados);
                    }
                    else {
                        enqueueSnackbar(response.Mensagem || 'Não foi possível carregar os detalhes da auditoria.', {
                            variant: 'error',
                            anchorOrigin: { vertical: 'top', horizontal: 'right' },
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    enqueueSnackbar('Erro ao carregar os detalhes da auditoria.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    return [3 /*break*/, 5];
                case 4:
                    setModalDetalheLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseModal = function () {
        setModalOpen(false);
        setModalDetalheLoading(false);
    };
    var carregarDados = useCallback(function (silencioso) {
        if (silencioso === void 0) { silencioso = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var response, dadosHistorico, infoColaborador, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!id)
                            return [2 /*return*/];
                        if (!silencioso)
                            setLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getHistoricoReeducando(id, periodoConsulta.dataInicio, periodoConsulta.dataFim)];
                    case 2:
                        response = _b.sent();
                        if (response.Status === STATUS_API.OK) {
                            dadosHistorico = response.dados || [];
                            setHistorico(dadosHistorico);
                            if ((_a = dadosHistorico[0]) === null || _a === void 0 ? void 0 : _a.reeducando) {
                                infoColaborador = getInfoColaborador(dadosHistorico[0]);
                                if (infoColaborador)
                                    setReeducandoInfo(infoColaborador);
                            }
                        }
                        else if (!silencioso) {
                            enqueueSnackbar(response.Mensagem || 'Não foi possível carregar o histórico de ponto.', {
                                variant: 'error',
                                anchorOrigin: { vertical: 'top', horizontal: 'right' },
                            });
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        console.error('Erro ao carregar histórico:', error_1);
                        if (!silencioso) {
                            enqueueSnackbar('Erro ao carregar o histórico de ponto.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (!silencioso)
                            setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [enqueueSnackbar, id, periodoConsulta]);
    var _m = useState(false), modalAprovarOpen = _m[0], setModalAprovarOpen = _m[1];
    var _o = useState(false), modalReprovarOpen = _o[0], setModalReprovarOpen = _o[1];
    var _p = useState(null), acaoDiaSelecionado = _p[0], setAcaoDiaSelecionado = _p[1];
    var _q = useState(''), observacaoAprovar = _q[0], setObservacaoAprovar = _q[1];
    var _r = useState(''), motivoReprovar = _r[0], setMotivoReprovar = _r[1];
    var _s = useState(false), erroMotivo = _s[0], setErroMotivo = _s[1];
    var _t = useState(false), isSubmitting = _t[0], setIsSubmitting = _t[1];
    var abrirModalAprovar = function (dia) {
        setAcaoDiaSelecionado(dia);
        setObservacaoAprovar('');
        setModalAprovarOpen(true);
    };
    var fecharModalAprovar = function () {
        setModalAprovarOpen(false);
        setTimeout(function () { return setAcaoDiaSelecionado(null); }, 200);
    };
    var abrirModalReprovar = function (dia) {
        setAcaoDiaSelecionado(dia);
        setMotivoReprovar('');
        setErroMotivo(false);
        setModalReprovarOpen(true);
    };
    var fecharModalReprovar = function () {
        setModalReprovarOpen(false);
        setTimeout(function () { return setAcaoDiaSelecionado(null); }, 200);
    };
    var handleAprovar = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!acaoDiaSelecionado || !id)
                        return [2 /*return*/];
                    setIsSubmitting(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 9, 10, 11]);
                    if (!acaoDiaSelecionado.id) return [3 /*break*/, 3];
                    return [4 /*yield*/, aprovarPonto(acaoDiaSelecionado.id, observacaoAprovar)];
                case 2:
                    _a = _c.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, aprovarPontoPorData(id, getDataKey(acaoDiaSelecionado.data), observacaoAprovar)];
                case 4:
                    _a = _c.sent();
                    _c.label = 5;
                case 5:
                    response = _a;
                    if (!((response === null || response === void 0 ? void 0 : response.Status) === 'OK')) return [3 /*break*/, 7];
                    enqueueSnackbar('Registro aprovado com sucesso.', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    fecharModalAprovar();
                    return [4 /*yield*/, carregarDados()];
                case 6:
                    _c.sent();
                    return [3 /*break*/, 8];
                case 7:
                    enqueueSnackbar((response === null || response === void 0 ? void 0 : response.Mensagem) || 'Erro ao aprovar bate-ponto.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    _c.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    _b = _c.sent();
                    enqueueSnackbar('Erro ao comunicar com o servidor no momento de aprovação.', {
                        variant: 'error',
                        anchorOrigin: { vertical: 'top', horizontal: 'right' },
                    });
                    return [3 /*break*/, 11];
                case 10:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handleReprovar = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!acaoDiaSelecionado || !id)
                        return [2 /*return*/];
                    if (motivoReprovar.trim().length === 0) {
                        setErroMotivo(true);
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 9, 10, 11]);
                    if (!acaoDiaSelecionado.id) return [3 /*break*/, 3];
                    return [4 /*yield*/, reprovarPonto(acaoDiaSelecionado.id, motivoReprovar)];
                case 2:
                    _a = _c.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, reprovarPontoPorData(id, getDataKey(acaoDiaSelecionado.data), motivoReprovar)];
                case 4:
                    _a = _c.sent();
                    _c.label = 5;
                case 5:
                    response = _a;
                    if (!((response === null || response === void 0 ? void 0 : response.Status) === 'OK')) return [3 /*break*/, 7];
                    enqueueSnackbar('Registro reprovado com sucesso.', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    fecharModalReprovar();
                    return [4 /*yield*/, carregarDados()];
                case 6:
                    _c.sent();
                    return [3 /*break*/, 8];
                case 7:
                    enqueueSnackbar((response === null || response === void 0 ? void 0 : response.Mensagem) || 'Erro ao reprovar bate-ponto.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    _c.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    _b = _c.sent();
                    enqueueSnackbar('Erro ao comunicar com o servidor no momento de reprovação.', {
                        variant: 'error',
                        anchorOrigin: { vertical: 'top', horizontal: 'right' },
                    });
                    return [3 /*break*/, 11];
                case 10:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handlePesquisarPeriodo = function () {
        var dataInicio = filtrosPeriodo.dataInicio, dataFim = filtrosPeriodo.dataFim;
        if (!dataInicio || !dataFim) {
            enqueueSnackbar('Selecione Data Inicial e Data Final.', { variant: 'warning', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            return;
        }
        if (getDataUtc(dataFim).getTime() < getDataUtc(dataInicio).getTime()) {
            enqueueSnackbar('Data Final não pode ser anterior à Data Inicial.', { variant: 'warning', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            return;
        }
        setPagina(1);
        setPeriodoConsulta({ dataInicio: dataInicio, dataFim: dataFim });
    };
    var handleLimparFiltros = function () {
        var periodoPadrao = getPeriodoPadraoHistorico();
        setFiltrosPeriodo(periodoPadrao);
        setPagina(1);
        setPeriodoConsulta(periodoPadrao);
    };
    useEffect(function () {
        carregarDados();
    }, [carregarDados]);
    useEffect(function () {
        var _a;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.reeducandoInfo) {
            var infoColaborador = getInfoColaborador(location.state.reeducandoInfo);
            if (infoColaborador)
                setReeducandoInfo(infoColaborador);
        }
    }, [location.state]);
    useEffect(function () {
        var intervalId = window.setInterval(function () { return carregarDados(true); }, POLLING_SINCRONIZACAO_MS);
        var handleFocus = function () { return carregarDados(true); };
        window.addEventListener('focus', handleFocus);
        return function () {
            window.clearInterval(intervalId);
            window.removeEventListener('focus', handleFocus);
        };
    }, [carregarDados]);
    var formatarData = function (dataStr) {
        var data = new Date(dataStr);
        var dia = String(data.getUTCDate()).padStart(2, '0');
        var mes = String(data.getUTCMonth() + 1).padStart(2, '0');
        var ano = data.getUTCFullYear();
        var diasSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
        var ddd = diasSemana[data.getUTCDay()];
        return "".concat(dia, "/").concat(mes, "/").concat(ano, " ").concat(ddd);
    };
    var getHorario = function (batidas, tipo) {
        var batida = batidas.find(function (b) { return b.tipo_batida === tipo; });
        return batida ? batida.horario_hhmmss.substring(0, 5) : null;
    };
    var isFimDeSemanaDia = function (dia) {
        if (dia.dia_tipo)
            return dia.dia_tipo === 'FIM_DE_SEMANA';
        var diaSemana = getDataUtc(dia.data).getUTCDay();
        return diaSemana === 0 || diaSemana === 6;
    };
    var isDataFuturaDia = function (dia) {
        if (typeof dia.futuro === 'boolean')
            return dia.futuro;
        return getDataUtc(dia.data).getTime() > getHojeUtc().getTime();
    };
    var possuiBatidasDia = function (dia) { return (dia.batidas || []).length > 0; };
    var isFimDeSemanaSemBatida = function (dia) {
        return isFimDeSemanaDia(dia) && !possuiBatidasDia(dia);
    };
    var isDiaNeutro = function (dia) {
        return isDataFuturaDia(dia) || isFimDeSemanaSemBatida(dia);
    };
    var isDiaSemDestaqueMarcacao = function (dia) {
        return isDataFuturaDia(dia) || isFimDeSemanaSemBatida(dia);
    };
    var isFimDeSemanaSemBatidaBloqueado = function (dia) {
        return isFimDeSemanaSemBatida(dia);
    };
    var renderTimeBox = function (time, isRequired) {
        if (!time) {
            return (_jsx(Box, __assign({ sx: {
                    px: 0.5,
                    py: 0.5,
                    borderRadius: 1,
                    border: "1px solid ".concat(isRequired ? '#FCA5A5' : '#E5E7EB'),
                    backgroundColor: isRequired ? '#FEF2F2' : '#F9FAFB',
                    display: 'inline-flex',
                    justifyContent: 'center',
                } }, { children: _jsx(Typography, __assign({ variant: 'body2', sx: {
                        color: isRequired ? '#EF4444' : '#9CA3AF',
                        fontWeight: isRequired ? 600 : 400,
                        fontFamily: 'monospace',
                        letterSpacing: 0,
                    } }, { children: "--:--" })) })));
        }
        return (_jsx(Box, __assign({ sx: {
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                border: '1px solid #E5E7EB',
                backgroundColor: '#FFFFFF',
                display: 'inline-flex',
                justifyContent: 'center',
                minWidth: 50,
            } }, { children: _jsx(Typography, __assign({ variant: 'body2', sx: { fontWeight: 500, color: '#1F2937', fontFamily: 'monospace' } }, { children: time })) })));
    };
    var renderStatus = function (ponto) {
        var _a, _b;
        var status_validacao = ponto.status_validacao, batidas = ponto.batidas;
        var cargaHoraria = (reeducandoInfo === null || reeducandoInfo === void 0 ? void 0 : reeducandoInfo.cargaHoraria) || 8;
        var batidasObrigatorias = getBatidasObrigatorias(cargaHoraria);
        var possuiTodasBatidasObrigatorias = batidasObrigatorias.every(function (tipo) { return Boolean(getHorario(batidas, tipo)); });
        if (isDiaNeutro(ponto)) {
            return null;
        }
        var label = status_validacao || 'PENDENTE';
        var config;
        var subtext = '';
        var icon = ((_a = ponto.bloqueio_fechamento_mensal) === null || _a === void 0 ? void 0 : _a.ativo) ? _jsx(LockIcon, { sx: { fontSize: 14, ml: 0.5 } }) : null;
        var temFalhaBiometrica = batidas.some(function (b) { return b.status === 'Falha Biometria'; });
        if (status_validacao === 'APROVADO') {
            config = COLORS.status.aprovado;
        }
        else if (status_validacao === 'REPROVADO') {
            config = COLORS.status.reprovado;
        }
        else if (status_validacao === 'EM_ANALISE') {
            config = COLORS.status.analise;
            subtext = 'Atestado Enviado';
        }
        else if (label === 'ENVIADO_FUNAC') {
            label = 'ENVIADO À FUNAC';
            config = COLORS.status.funac;
            icon = _jsx(LockIcon, { sx: { fontSize: 14, ml: 0.5 } });
        }
        else if (temFalhaBiometrica) {
            label = 'ALERTA BIOMÉTRICO';
            config = COLORS.status.alerta;
            subtext = '! Falha técnica em ' + ((_b = batidas.find(function (b) { return b.status === 'Falha Biometria'; })) === null || _b === void 0 ? void 0 : _b.tipo_batida);
        }
        else if (batidas.some(function (b) { return b.status === 'Falha Identidade'; })) {
            label = 'ALERTA IDENTIDADE';
            config = COLORS.status.alerta;
            subtext = '! Divergência de identidade';
        }
        else if (batidas.length === 0) {
            label = 'AUSÊNCIA TOTAL';
            config = COLORS.status.alerta;
            subtext = 'Marcação Incompleta';
        }
        else if (!possuiTodasBatidasObrigatorias) {
            label = 'AUSÊNCIA PARCIAL';
            config = COLORS.status.alerta;
            subtext = 'Marcação Incompleta';
        }
        else {
            label = 'REGULAR';
            config = COLORS.status.regular;
        }
        if (label === 'PENDENTE') {
            if (ponto.justificativa_status === 'APROVADA') {
                subtext = 'Justificativa Aprovada';
            }
            else if (ponto.justificativa_status === 'REPROVADA') {
                subtext = 'Justificativa Reprovada';
            }
        }
        return (_jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' } }, { children: [_jsx(Chip, { label: _jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [label, icon] })), size: 'small', sx: {
                        backgroundColor: config.bg,
                        color: config.text,
                        fontWeight: 700,
                        borderRadius: 1,
                        fontSize: '0.65rem',
                        height: 22,
                    } }), subtext && (_jsxs(Typography, __assign({ variant: 'caption', sx: {
                        color: subtext === 'Justificativa Aprovada'
                            ? '#1E40AF'
                            : subtext === 'Justificativa Reprovada' || subtext.startsWith('!')
                                ? '#991B1B'
                                : label === 'EM_ANALISE'
                                    ? '#1E40AF'
                                    : '#854D0E',
                        fontSize: '0.7rem',
                        mt: 1,
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                    } }, { children: [subtext.startsWith('!') && _jsx(ErrorIcon, { sx: { fontSize: 12 } }), subtext.replace('!', '')] })))] })));
    };
    var bloqueioAtivo = (_a = historico.find(function (dia) { var _a; return (_a = dia.bloqueio_fechamento_mensal) === null || _a === void 0 ? void 0 : _a.ativo; })) === null || _a === void 0 ? void 0 : _a.bloqueio_fechamento_mensal;
    var mensagemBloqueio = (bloqueioAtivo === null || bloqueioAtivo === void 0 ? void 0 : bloqueioAtivo.mensagem) || null;
    var paginaAtualHistorico = historico.slice((pagina - 1) * porPagina, pagina * porPagina);
    return (_jsxs(ContainerPainel, __assign({ pagina_acima: PAGINAS.GF_VALIDACAO_DIARIA, pagina: 'Hist\u00F3rico de Ponto', pagina_especifica_permissao: FUNCIONALIDADES.GF_VALIDACAO_DIARIA, titulo_pagina: 'Hist\u00F3rico de Ponto', backgroundColor: '#f8f9fa' }, { children: [_jsxs(Box, __assign({ sx: { minWidth: '100%' } }, { children: [_jsx(Button, __assign({ startIcon: _jsx(ChevronLeft, {}), onClick: function () { return navigate(ROUTES.GF_VALIDACAO_DIARIA); }, sx: { textTransform: 'none', color: '#6B7280', mb: 1 } }, { children: "Voltar para a listagem" })), reeducandoInfo && (_jsxs(Card, __assign({ variant: 'outlined', sx: { p: 2, borderRadius: 2, borderColor: '#E5E7EB', boxShadow: 'none', mb: 2 } }, { children: [_jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', spacing: 2 }, { children: [_jsx(Avatar, __assign({ sx: { bgcolor: COLORS.primary, width: 48, height: 48 } }, { children: reeducandoInfo.nome[0] })), _jsxs(Box, { children: [_jsx(Typography, __assign({ variant: 'h6', sx: { fontWeight: 700, color: '#111827', textTransform: 'uppercase' } }, { children: reeducandoInfo.nome })), _jsxs(Typography, __assign({ variant: 'body2', sx: { color: '#6B7280' } }, { children: ["C\u00F3digo: ", reeducandoInfo.codigo, " \u00B7 ", reeducandoInfo.empresa, " \u00B7 ", reeducandoInfo.cargaHoraria, "h"] }))] })] })), mensagemBloqueio && (_jsxs(Box, __assign({ sx: {
                                    p: 1.5,
                                    mt: 2,
                                    borderRadius: 1.5,
                                    backgroundColor: '#DCFCE7',
                                    border: '1px solid #BBF7D0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                } }, { children: [_jsx(LockIcon, { sx: { color: '#166534', fontSize: 20 } }), _jsx(Typography, __assign({ variant: 'body2', sx: { color: '#166534', fontWeight: 600 } }, { children: mensagemBloqueio }))] })))] }))), _jsx(Card, __assign({ variant: 'outlined', sx: { p: 2, borderRadius: 2, borderColor: '#E5E7EB', boxShadow: 'none', mb: 2 } }, { children: _jsxs(Stack, __assign({ direction: { xs: 'column', md: 'row' }, spacing: 1.5, alignItems: { xs: 'stretch', md: 'flex-end' } }, { children: [_jsx(TextField, { label: 'Data Inicial', type: 'date', value: filtrosPeriodo.dataInicio, onChange: function (event) { return setFiltrosPeriodo(function (prev) { return (__assign(__assign({}, prev), { dataInicio: event.target.value })); }); }, size: 'small', InputLabelProps: { shrink: true }, sx: { width: { xs: '100%', md: 180 } } }), _jsx(TextField, { label: 'Data Final', type: 'date', value: filtrosPeriodo.dataFim, onChange: function (event) { return setFiltrosPeriodo(function (prev) { return (__assign(__assign({}, prev), { dataFim: event.target.value })); }); }, size: 'small', InputLabelProps: { shrink: true }, sx: { width: { xs: '100%', md: 180 } } }), _jsx(Button, __assign({ variant: 'contained', onClick: handlePesquisarPeriodo, sx: { textTransform: 'none', backgroundColor: COLORS.primary, '&:hover': { backgroundColor: '#005232' } } }, { children: "Pesquisar" })), _jsx(Button, __assign({ variant: 'outlined', onClick: handleLimparFiltros, sx: { textTransform: 'none', borderColor: '#D1D5DB', color: '#374151' } }, { children: "Limpar" }))] })) })), _jsxs(Typography, __assign({ variant: 'body2', sx: { color: '#6B7280', mb: 1 } }, { children: ["Mostrando ", paginaAtualHistorico.length, " de ", historico.length, " dias"] })), _jsx(TableContainer, __assign({ component: Paper, variant: 'outlined', sx: { borderRadius: 2, borderColor: '#E5E7EB', boxShadow: 'none' } }, { children: _jsxs(Table, __assign({ size: 'small' }, { children: [_jsx(TableHead, __assign({ sx: { backgroundColor: '#F9FAFB' } }, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ sx: { color: '#9CA3AF', fontWeight: 600, fontSize: '0.75rem', py: 1.5 } }, { children: "DATA" })), _jsx(TableCell, __assign({ sx: { color: '#9CA3AF', fontWeight: 600, fontSize: '0.75rem', textAlign: 'center' } }, { children: "E1" })), _jsx(TableCell, __assign({ sx: { color: '#9CA3AF', fontWeight: 600, fontSize: '0.75rem', textAlign: 'center' } }, { children: "S1" })), _jsx(TableCell, __assign({ sx: { color: '#9CA3AF', fontWeight: 600, fontSize: '0.75rem', textAlign: 'center' } }, { children: "E2" })), _jsx(TableCell, __assign({ sx: { color: '#9CA3AF', fontWeight: 600, fontSize: '0.75rem', textAlign: 'center' } }, { children: "S2" })), _jsx(TableCell, __assign({ sx: { color: '#9CA3AF', fontWeight: 600, fontSize: '0.75rem' } }, { children: "STATUS" })), _jsx(TableCell, __assign({ sx: { color: '#9CA3AF', fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' } }, { children: "A\u00C7\u00D5ES" }))] }) })), _jsxs(TableBody, { children: [loading && (_jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: 7, align: 'center', sx: { py: 4 } }, { children: "Carregando hist\u00F3rico..." })) })), !loading && paginaAtualHistorico.length === 0 && (_jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: 7, align: 'center', sx: { py: 4 } }, { children: "Nenhum registro encontrado." })) })), !loading &&
                                            paginaAtualHistorico.map(function (dia, idx) {
                                                var _a, _b, _c, _d;
                                                var e1 = getHorario(dia.batidas, 'E1');
                                                var s1 = getHorario(dia.batidas, 'S1');
                                                var e2 = getHorario(dia.batidas, 'E2');
                                                var s2 = getHorario(dia.batidas, 'S2');
                                                var cargaHoraria = (reeducandoInfo === null || reeducandoInfo === void 0 ? void 0 : reeducandoInfo.cargaHoraria) || 8;
                                                var status = dia.status_validacao;
                                                var bloqueioDia = dia.bloqueio_fechamento_mensal;
                                                var isDiaBloqueado = Boolean(bloqueioDia === null || bloqueioDia === void 0 ? void 0 : bloqueioDia.ativo);
                                                var mensagemBloqueioDia = isDiaBloqueado ? (bloqueioDia === null || bloqueioDia === void 0 ? void 0 : bloqueioDia.mensagem) || 'Folha enviada à FUNAC. Registro bloqueado para edição.' : '';
                                                var diaSemDestaqueMarcacao = isDiaSemDestaqueMarcacao(dia);
                                                var fimDeSemanaSemBatidaBloqueado = isFimDeSemanaSemBatidaBloqueado(dia);
                                                var horarios = { E1: e1, S1: s1, E2: e2, S2: s2 };
                                                var batidasObrigatorias = getBatidasObrigatorias(cargaHoraria);
                                                var deveDestacarMarcacao = function (tipo) { return !diaSemDestaqueMarcacao && batidasObrigatorias.includes(tipo) && !horarios[tipo]; };
                                                var renderCelulaBatida = function (tipo) { return (_jsx(TableCell, __assign({ align: 'center' }, { children: _jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 46, justifyContent: 'center' } }, { children: [renderTimeBox(horarios[tipo], deveDestacarMarcacao(tipo)), deveDestacarMarcacao(tipo) && (_jsx(Typography, __assign({ variant: 'caption', sx: { color: '#EF4444', fontSize: '0.65rem', mt: 0.5, whiteSpace: 'nowrap' } }, { children: "Marca\u00E7\u00E3o Incompleta" })))] })) }), tipo)); };
                                                var canAprovar = !isDiaBloqueado && !fimDeSemanaSemBatidaBloqueado && status !== 'EM_ANALISE' && ((_b = (_a = dia.acoes) === null || _a === void 0 ? void 0 : _a.pode_aprovar) !== null && _b !== void 0 ? _b : true);
                                                var canReprovar = !isDiaBloqueado && !fimDeSemanaSemBatidaBloqueado && status !== 'EM_ANALISE' && ((_d = (_c = dia.acoes) === null || _c === void 0 ? void 0 : _c.pode_reprovar) !== null && _d !== void 0 ? _d : true);
                                                var canVisualizar = !fimDeSemanaSemBatidaBloqueado;
                                                var tooltipBlocked = mensagemBloqueioDia ||
                                                    (status === 'EM_ANALISE'
                                                        ? 'Aguardando análise da justificativa.'
                                                        : fimDeSemanaSemBatidaBloqueado
                                                            ? 'Fim de semana sem marcação não exige validação.'
                                                            : '');
                                                return (_jsxs(TableRow, __assign({ hover: true, sx: { '&:last-child td, &:last-child th': { border: 0 } } }, { children: [_jsxs(TableCell, __assign({ sx: { fontWeight: 500, color: '#374151' } }, { children: [formatarData(dia.data).split(' ')[0], ' ', _jsx(Typography, __assign({ component: 'span', variant: 'caption', sx: { color: '#9CA3AF', ml: 0.5 } }, { children: formatarData(dia.data).split(' ')[1] }))] })), TIPOS_BATIDA.map(function (tipo) { return renderCelulaBatida(tipo); }), _jsx(TableCell, { children: renderStatus(dia) }), _jsx(TableCell, __assign({ align: 'right' }, { children: _jsxs(Stack, __assign({ direction: 'row', spacing: 0.5, justifyContent: 'flex-end' }, { children: [_jsx(Tooltip, __assign({ title: canVisualizar ? 'Visualizar Detalhes' : 'Fim de semana sem marcação não exige visualização.' }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: 'small', onClick: function () { return handleOpenModal(dia); }, disabled: !canVisualizar, sx: {
                                                                                    border: '1px solid #E5E7EB',
                                                                                    borderRadius: 1.5,
                                                                                    p: 0.5,
                                                                                    transition: 'all 0.2s',
                                                                                    backgroundColor: '#FFFFFF',
                                                                                    '&.Mui-disabled': { opacity: 0.4, backgroundColor: '#F3F4F6' },
                                                                                    '&:hover': {
                                                                                        backgroundColor: canVisualizar ? '#ea580c' : undefined,
                                                                                        borderColor: canVisualizar ? '#ea580c' : undefined,
                                                                                        '& .MuiSvgIcon-root': { color: canVisualizar ? '#FFFFFF' : undefined },
                                                                                    },
                                                                                } }, { children: _jsx(VisibilityIcon, { sx: { fontSize: 18, color: '#4B5563' } }) })) }) })), _jsx(Tooltip, __assign({ title: tooltipBlocked || (status === 'APROVADO' ? 'Já aprovado' : 'Aprovar') }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: 'small', onClick: function () { return abrirModalAprovar(dia); }, disabled: !canAprovar || status === 'APROVADO', sx: {
                                                                                    border: '1px solid #E5E7EB',
                                                                                    borderRadius: 1.5,
                                                                                    p: 0.5,
                                                                                    backgroundColor: status === 'APROVADO' ? '#166534' : 'transparent',
                                                                                    color: status === 'APROVADO' ? '#FFFFFF' : '#4B5563',
                                                                                    '&.Mui-disabled': { opacity: status === 'APROVADO' ? 1 : 0.4 },
                                                                                    '&:hover': {
                                                                                        backgroundColor: !canAprovar || status === 'APROVADO' ? undefined : '#DCFCE7',
                                                                                        borderColor: !canAprovar || status === 'APROVADO' ? undefined : '#DCFCE7',
                                                                                        color: !canAprovar || status === 'APROVADO' ? undefined : '#166534',
                                                                                    },
                                                                                } }, { children: _jsx(CheckIcon, { sx: { fontSize: 18 } }) })) }) })), _jsx(Tooltip, __assign({ title: tooltipBlocked || (status === 'REPROVADO' ? 'Já reprovado' : 'Reprovar') }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: 'small', onClick: function () { return abrirModalReprovar(dia); }, disabled: !canReprovar || status === 'REPROVADO', sx: {
                                                                                    border: '1px solid #E5E7EB',
                                                                                    borderRadius: 1.5,
                                                                                    p: 0.5,
                                                                                    backgroundColor: status === 'REPROVADO' ? '#991B1B' : 'transparent',
                                                                                    color: status === 'REPROVADO' ? '#FFFFFF' : '#4B5563',
                                                                                    '&.Mui-disabled': { opacity: status === 'REPROVADO' ? 1 : 0.4 },
                                                                                    '&:hover': {
                                                                                        backgroundColor: !canReprovar || status === 'REPROVADO' ? undefined : '#FEE2E2',
                                                                                        borderColor: !canReprovar || status === 'REPROVADO' ? undefined : '#FEE2E2',
                                                                                        color: !canReprovar || status === 'REPROVADO' ? undefined : '#991B1B',
                                                                                    },
                                                                                } }, { children: _jsx(CloseIcon, { sx: { fontSize: 18 } }) })) }) }))] })) }))] }), dia.id || getDataKey(dia.data) || idx));
                                            })] })] })) })), _jsxs(Card, __assign({ variant: 'outlined', sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            p: 2,
                            borderRadius: 2,
                            borderColor: '#e5e7eb',
                            boxShadow: 'none',
                            mt: 2,
                        } }, { children: [_jsx("span", {}), _jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 3 } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#6B7280' } }, { children: "Por p\u00E1gina:" })), _jsxs(Select, __assign({ value: porPagina, onChange: function (e) {
                                                    setPorPagina(Number(e.target.value));
                                                    setPagina(1);
                                                }, size: 'small', variant: 'standard', disableUnderline: true, sx: { fontSize: '0.875rem', fontWeight: 500, color: '#1f2937' } }, { children: [_jsx(MenuItem, __assign({ value: 15 }, { children: "15" })), _jsx(MenuItem, __assign({ value: 30 }, { children: "30" })), _jsx(MenuItem, __assign({ value: 50 }, { children: "50" }))] }))] })), _jsx(Pagination, { count: Math.ceil(historico.length / porPagina), page: pagina, onChange: function (_, value) { return setPagina(value); }, shape: 'rounded', size: 'small', variant: 'outlined', sx: {
                                            '& .MuiPaginationItem-root': {
                                                borderColor: '#E5E7EB',
                                            },
                                        } })] }))] }))] })), _jsx(ModalVisualizar, { open: modalOpen, onClose: handleCloseModal, diaSelecionado: diaSelecionado, reeducandoInfo: reeducandoInfo, formatarData: formatarData, isLoadingDetalhes: modalDetalheLoading }), _jsx(ModalAprovar, { open: modalAprovarOpen, onClose: fecharModalAprovar, onConfirm: handleAprovar, observacao: observacaoAprovar, onObservacaoChange: setObservacaoAprovar, isSubmitting: isSubmitting }), _jsx(ModalReprovar, { open: modalReprovarOpen, onClose: fecharModalReprovar, onConfirm: handleReprovar, motivo: motivoReprovar, onMotivoChange: function (value) {
                    setMotivoReprovar(value);
                    if (value.trim().length > 0)
                        setErroMotivo(false);
                }, erroMotivo: erroMotivo, isSubmitting: isSubmitting })] })));
}
